// extracted by mini-css-extract-plugin
module.exports = {"inchButton":"RimFilter_inchButton__bvtpW","surfix":"RimFilter_surfix__RgwGJ","sliders":"RimFilter_sliders__Ik4LH"};